import type { JSX } from 'react'

import { logout } from '../actions/AuthActions'
import { useAppDispatch, useAppSelector } from '../hooks'

export default function LogoutButton (): JSX.Element | null {
  const isAuthenticated = useAppSelector<boolean>(state => state.user.isAuthenticated)
  const dispatch = useAppDispatch()

  if (!isAuthenticated) {
    return null
  }

  function onLogoutClick () {
    dispatch(logout())
  }

  return (
    <a className='btn btn-light' onClick={() => onLogoutClick()}>Kirjaudu ulos</a>
  )
}
